
import { DATA_OPERATIONS } from '../../reducers/data';

import getOperationById from './getOperationById';
import getUsekQuantity from './getUsekQuantity';

const getOperationItems = (operationItems, pricelistData) => {
    let items = [];
    pricelistData.items.forEach(item => {
        let operationItem = operationItems[item.id];
        if (operationItem) {
            items.push({
                id: item.id,
                title: item.title,
                price: item.price,
                quantity: operationItem.quantity,
                mj: getOperationById(item.opId).mj
            });
        }
    });
    return items;
}

export default function calcSummary(
    usekMezItems, calculationOperations, pricelistData, usekMezAttributes
    ) {

    let summary = {
        price: 0,
        operationItems: {}
    };
    usekMezItems.forEach(usek => {
        let attributes = usekMezAttributes[usek.properties.id_usek];
        let quantity = getUsekQuantity(attributes);
        DATA_OPERATIONS.forEach(operation => {
            let calcOp = calculationOperations[`${usek.properties.id_usek}_${operation.id}`];
            if (calcOp) {
                let mj = getOperationById(calcOp.opId).mj;
                summary.price = summary.price + (calcOp.pricePerUnit * quantity[mj]);
                summary.operationItems[calcOp.itemId] = summary.operationItems[calcOp.itemId] || {quantity: 0};
                summary.operationItems[calcOp.itemId].quantity = summary.operationItems[calcOp.itemId].quantity + quantity[mj];
            }
        });
    });

    return {
        price: summary.price,
        operationItems: getOperationItems(summary.operationItems, pricelistData)
    };
}
